import { action, makeAutoObservable } from 'mobx';

import { State } from '~/store/types';

export interface ConfirmationShowProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

class ConfirmationStore {
  rootStore: State;
  title: string | null = null;
  showModal = false;
  message: string | null = null;
  onConfirm: (() => void) | null = null;
  onCancel?: () => void;
  constructor(rootStore: State) {
    makeAutoObservable(this, {
      show: action.bound,
      cancel: action.bound,
    });
    this.rootStore = rootStore;
  }

  show({ title, message, onConfirm, onCancel }: ConfirmationShowProps) {
    this.title = title;
    this.message = message;
    this.onCancel = onCancel;
    this.onConfirm = onConfirm;
    this.showModal = true;
  }
  confirm = () => {
    if (this.onConfirm) {
      this.onConfirm();
    }
    this.clear();
  };

  cancel = () => {
    if (this.onCancel) {
      this.onCancel();
    }
    this.clear();
  };

  private clear() {
    this.onConfirm = null;
    this.onCancel = undefined;
    this.title = null;
    this.message = null;
    this.showModal = false;
  }
}

export default ConfirmationStore;
